export interface Variant {
  id: string;
  name: string;
  price: number;
  priceId: string;
  inStock: boolean;
  image: string;
  treatmentCapacity?: string;
}

export interface ProductSize {
  id: string;
  name: string;
  volume: string;
  price: number;
  priceId: string;
  inStock: boolean;
  image: string;
  treatmentCapacity: string;
  variants?: Variant[];
}

export interface ProductImage {
  id: string;
  url: string;
  alt: string;
}

export interface ProductProps {
  id: string;
  name: string;
  description: string;
  currency?: string;
  images: ProductImage[];
  sizes: ProductSize[];
}

// FuelOX Marine Product Data
export const fuelOXProduct: ProductProps = {
  id: "fuelox-marine",
  name: "FuelOX Marine",
  description: "Fuel Ox Marine® with Combustion Catalyst additive is a unique, proprietary fuel treatment designed to improve marine vehicle performance and extend engine longevity. The enhanced stability and dispersant/detergent features make it indispensable in dealing with problem fuels or fuels in storage. Fuel Ox Marine® with Combustion Catalyst also works in any combustible engine including automobiles, trucks, off-road vehicles, heavy equipment, trains, and ships, etc. Thorough testing and application has proven this additive to be compatible and 100% soluble with all types of middle distillate and heavy fuel oils.",
  currency: "USD",
  images: [
    {
      id: "img1",
      url: "/images/products/fuelox-marine-spout-v2.png",
      alt: "FuelOX Marine 8oz bottle with precision spout cap for easy pouring"
    },
    {
      id: "img2",
      url: "/images/products/fuelox-marine-standard-v2.png",
      alt: "FuelOX Marine 8oz standard bottle with dual measuring caps"
    },
    {
      id: "img3",
      url: "/images/products/fuelox-marine-16oz-v2.png",
      alt: "FuelOX Marine 16oz bottle, perfect for larger vessels"
    }
  ],
  sizes: [
    {
      id: "size-8oz",
      name: "8 oz",
      volume: "8 oz",
      price: 44.99,
      priceId: "price_1R8RnuHlwZSAFBpehFbQXbry",
      inStock: true,
      image: "/images/products/fuelox-marine-standard-v2.png",
      treatmentCapacity: "Treats up to 625 gallons",
      variants: [
        {
          id: "variant-8oz-spout",
          name: "Spout Bottle",
          price: 29.99,
          priceId: "price_1R8RmrHlwZSAFBpeHg4FtVuK",
          inStock: true,
          image: "/images/products/fuelox-marine-spout-v2.png",
          treatmentCapacity: "Treats up to 320 gallons"
        },
        {
          id: "variant-8oz-standard",
          name: "Standard Bottle",
          price: 44.99,
          priceId: "price_1R8RnuHlwZSAFBpehFbQXbry",
          inStock: true,
          image: "/images/products/fuelox-marine-standard-v2.png",
          treatmentCapacity: "Treats up to 625 gallons"
        }
      ]
    },
    {
      id: "size-16oz",
      name: "16 oz",
      volume: "16 oz",
      price: 79.99,
      priceId: "price_1R8RpkHlwZSAFBpeurJLdbqM",
      inStock: true,
      image: "/images/products/fuelox-marine-16oz-v2.png",
      treatmentCapacity: "Treats up to 1250 gallons"
    }
  ]
};
